module.exports = __webpack_public_path__ + "logo-basic.svg?28e3746a9a45fd2b9a52a51dafe8a2a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-basic.svg
// module id = 101
// module chunks = 0